import Vue from 'vue';
import 'vue-good-table/dist/vue-good-table.css' // import the styles
import { VueGoodTable } from 'vue-good-table' // see https://github.com/xaksis/vue-good-table
import { Component } from 'vue-property-decorator';
import { Area, Cell, Event, Row } from './links.model'
import LinksService from './links.service';

@Component({
    name: 'links',
    components: {
        VueGoodTable
    },
})
export default class LinksComponent extends Vue {
    // lists to populate in dropdowns
    areasList: Area[] = [];
    cellsList: Cell[] = [];
    eventsList: Event[] = [];
    linksList: Row[] = [];
    // selected rows of area,cell and event
    selectedRows: Row[] = [];
    // Service to fetch data from the API
    service: LinksService = new LinksService();
    // New Link for creation
    newLink: Row = new Row();

    columnsConfig = [
        {
            label: this.getStrArea(),
            field: 'areaName',
        },
        {
            label: this.getStrCell(),
            field: 'cellName',
        },
        {
            label: this.getStrEvent(),
            field: 'eventName',
        },
        //{
        //    label: 'Id',
        //    field: 'id',
        //    type: 'number',
        //}
    ];
    selectConfig = {
        enabled: true,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: this.getSelectionTextStr(),
        clearSelectionText: this.getClearStr(),
        disableSelectInfo: false, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
    };
    getClearStr() {
        return this.$i18n.t('comClear').toString();
    }
    getSelectionTextStr() {
        return this.$i18n.t('comSelectionCnt').toString();
    }
    getStrArea() {
        return this.$i18n.t('txtArea').toString();
    }
    getStrCell() {
        return this.$i18n.t('txtCell').toString();
    }
    getStrEvent() {
        return this.$i18n.t('txtEvent').toString();
    }


    mounted() {
        this.fetchAndClear();
    }

    fetchEvents() {
        this.service.fetchEvents()
            .then(data => {
                this.eventsList = data as Event[];
            });
    }

    fetchCells() {
        this.service.fetchcells()
            .then(data => {
                this.cellsList = data as Cell[];
            });
    }

    fetchareas() {
        this.service.fetchareas()
            .then(data => {
                this.areasList = data as Area[];                
            });
    }

    fetchLinks() {
        this.service.fetchLinks()
            .then(data => {
                this.linksList = data as Row[];                
            });
    }

    postLink() {
        this.service.postLink(this.newLink);
        this.fetchAndClear();
    }

    deleteSelected() {
        if (this.selectedRows.length > 0) {
            this.service.deleteLinks(this.selectedRows);
            this.fetchAndClear();
        }
    }

    clearSelection() {
        this.selectedRows = [];
    }

    // Fetches the data after 1 second and also clears the inputs etc.s
    fetchAndClear() {
        // Create a new Promise and resolve after 1 seconds
        var myTimerPromise = new Promise((resolve, reject) => {
            setTimeout(resolve, 1000);  // "resolve" is already a function, no need for another anonymous function here
        });

        // Fetch data now, within Promise.all()
        Promise.all([myTimerPromise]).then(() => {

            this.fetchLinks();
            this.fetchEvents();
            this.fetchareas();
            this.fetchCells();
            this.clearSelection();
            this.newLink = new Row();
        });
    }

    selectionChanged(params) {
        console.log("selection cell=" + JSON.stringify(params));
        this.selectedRows = params.selectedRows;
    }
}